document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.swiper-banner', {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            init: function () {
                var slideCount = this.slides.length;

                if (slideCount < 2) {
                    document.querySelector('.swiper-button-next').style.display = 'none';
                    document.querySelector('.swiper-button-prev').style.display = 'none';
                    document.querySelector('.swiper-pagination').style.display = 'none';
                }
            }
        }
    });

    var swiper = new Swiper('.swiper-gallery', {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            init: function () {
                var slideCount = this.slides.length;

                if (slideCount < 2) {
                    document.querySelector('.swiper-button-next').style.display = 'none';
                    document.querySelector('.swiper-button-prev').style.display = 'none';
                    document.querySelector('.swiper-pagination').style.display = 'none';
                }
            }
        }
    });
});
